import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import API from "../../../services/api";

import {
    ArrowLeft,
    Bell,
    RefreshCw,
    CheckCheck,
    Trash2
} from "lucide-react";

import NotificationCard from "../../../components/delivery/NotificationCard/NotificationCard";

import "./DeliveryNotifications.css";

function DeliveryNotifications() {

    const navigate = useNavigate();

    const [notifications, setNotifications] = useState([]);

    const [loading, setLoading] = useState(true);

    const fetchNotifications = async () => {

        try {

            setLoading(true);

            const response = await API.get(
                "/delivery/notifications"
            );

            if (response.data.success) {

                setNotifications(
                    response.data.notifications
                );

            }

        }

        catch (error) {

            console.log(error);

        }

        finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        fetchNotifications();

    }, []);

    const markAsRead = async (id) => {

        try {

            await API.patch(
                `/delivery/notifications/${id}/read`
            );

            fetchNotifications();

        }

        catch (error) {

            console.log(error);

        }

    };

    const deleteNotification = async (id) => {

        try {

            await API.delete(
                `/delivery/notifications/${id}`
            );

            fetchNotifications();

        }

        catch (error) {

            console.log(error);

        }

    };

    const markAllRead = async () => {

        try {

            await API.patch(
                "/delivery/notifications/read-all"
            );

            fetchNotifications();

        }

        catch (error) {

            console.log(error);

        }

    };

    const clearAll = async () => {

        try {

            await API.delete(
                "/delivery/notifications/clear"
            );

            fetchNotifications();

        }

        catch (error) {

            console.log(error);

        }

    };

    const unreadCount = notifications.filter(
        (item) => !item.isRead
    ).length;

    return (

        <div className="delivery-notifications-page">

            {/* ================= Header ================= */}

            <div className="notification-header">

                <div className="notification-title">

                    <button

                        className="back-btn"

                        onClick={() =>
                            navigate("/delivery/home")
                        }

                    >

                        <ArrowLeft size={22} />

                    </button>

                    <div>

                        <h1>

                            Notifications

                            <span className="notification-count">

                                {notifications.length}

                            </span>

                        </h1>

                        <p>

                            Stay updated with your latest delivery activities.

                        </p>

                    </div>

                </div>

                <div className="notification-actions">

                    <button

                        className="refresh-btn"

                        onClick={fetchNotifications}

                    >

                        <RefreshCw size={18} />

                        Refresh

                    </button>

                    <button

                        className="mark-btn"

                        onClick={markAllRead}

                        disabled={!notifications.length}

                    >

                        <CheckCheck size={18} />

                        Mark All Read

                    </button>

                    <button

                        className="clear-btn"

                        onClick={clearAll}

                        disabled={!notifications.length}

                    >

                        <Trash2 size={18} />

                        Clear All

                    </button>

                </div>

            </div>

            {/* ================= Summary ================= */}

            {

                notifications.length > 0 && (

                    <div className="notification-summary">

                        <div className="summary-card">

                            <Bell size={18} />

                            <div>

                                <h4>

                                    Total Notifications

                                </h4>

                                <span>

                                    {notifications.length}

                                </span>

                            </div>

                        </div>

                        <div className="summary-card unread">

                            <Bell size={18} />

                            <div>

                                <h4>

                                    Unread

                                </h4>

                                <span>

                                    {unreadCount}

                                </span>

                            </div>

                        </div>

                    </div>

                )

            }

            {/* ================= Loading ================= */}

            {

                loading ? (

                    <div className="notifications-loading">

                        <div className="loader"></div>

                        <p>

                            Loading Notifications...

                        </p>

                    </div>

                )

                    :

                    notifications.length === 0 ?

                        (

                            <div className="empty-state">

                                <div className="empty-icon">

                                    🔔

                                </div>

                                <h2>

                                    You're All Caught Up!

                                </h2>

                                <p>

                                    No new notifications.

                                    Delivery updates,

                                    payments,

                                    ratings,

                                    and system alerts

                                    will appear here.

                                </p>

                                <button

                                    className="refresh-empty-btn"

                                    onClick={fetchNotifications}

                                >

                                    <RefreshCw size={18} />

                                    Refresh

                                </button>

                            </div>

                        )

                        :

                        (

                            <div className="notifications-list">

                                {

                                    notifications.map(

                                        (notification) => (

                                            <NotificationCard

                                                key={notification._id}

                                                notification={notification}

                                                onRead={markAsRead}

                                                onDelete={deleteNotification}

                                            />

                                        )

                                    )

                                }

                            </div>

                        )

            }

        </div>

    );

}

export default DeliveryNotifications;